<template>
  <div class="template-container">
    <CustomDialog :title="title" @close="cancel" :visible.sync="dialogShow" width="860px" append-to-body top="5vh">
      <div slot="content" class="template-warp" v-loading="loading">
        <div class="select-warp">
          <div class="flex-sh"> <span class="colorF54A">*</span> 模版类型：</div>
          <el-select class="w100_" @change="recipeTemplateTypeChange" filterable
            v-model="editRecipeForm.recipeTemplateTypeId" allow-create placeholder="请选择">
            <el-option v-for="item in typeList" :key="item.recipeTemplateTypeId" :label="item.recipeTemplateTypeName"
              :value="item.recipeTemplateTypeId">
            </el-option>
          </el-select>
        </div>
        <!-- 病例模块 -->
        <div class="case-warp">
          <div class="case-title font600 size15">模版信息</div>
          <div class="case-item">
            <div class="case-item-title"><span class="colorF54A">*</span>名称</div>
            <el-input :class="{ 'isInvalid': isInputInvalid }" type="text" class="item-textarea"
              v-model="editRecipeForm.recipeTemplateName" />
          </div>
          <div class="case-item">
            <div class="case-item-title">源于</div>
            <el-input type="text" class="item-textarea" v-model="editRecipeForm.origin" />
          </div>
          <div class="case-item">
            <div class="case-item-title">功用</div>
            <el-input type="text" class="item-textarea" v-model="editRecipeForm.effect" />
          </div>
          <div class="case-item">
            <div class="case-item-title">主治</div>
            <el-input type="text" class="item-textarea" v-model="editRecipeForm.attending" />
          </div>
          <div class="case-item">
            <div class="case-item-title">加减法</div>
            <el-input type="text" class="item-textarea" v-model="editRecipeForm.method" />
          </div>
          <div class="case-item">
            <div class="case-item-title">建议</div>
            <el-input type="text" class="item-textarea" v-model="editRecipeForm.suggestion" />
          </div>
        </div>
        <div class="prescription-warp">
          <div class="prescription-top">
            <div class="flex align-i-c">
              <div>处方明细</div>
              <div class="drug-type" v-if="editRecipeForm.type == '0'">
                <div>类型：</div>
                <el-select @change="typeChange($event)" ref="select" class="type-select"
                  v-model="editRecipeForm.doseType" placeholder="">
                  <el-option v-for="obj in recipeList" :key="obj.value" :label="obj.label" :disabled="obj.disabled"
                    :value="obj.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div>
              <el-button plain size="small" :disabled="editRecipeForm.type ? true : false"
                @click="addDrug">中药处方</el-button>
              <el-button plain size="small" class="ml16" :disabled="editRecipeForm.type ? true : false"
                @click="addPhysio">理疗处方</el-button>
            </div>
          </div>
          <div v-if="editRecipeForm.type && editRecipeForm.type == '0'">
            <div class="drug-title">
              <div class="drug-index">
                <img :src="imgArr.drugIcon" class="drug-icon">
                <div class="font600 size14 color6671">中药处方</div>
                <div class="drug_total">
                  <span>{{ editRecipeForm.recipeTemplateDrugs.length - 1 }}味，单剂{{ computedWeight(editRecipeForm).single }}g，合计{{ computedWeight(editRecipeForm).count }}g</span>
                  <el-tooltip v-if="['制膏', '制丸', '打粉'].includes(editRecipeForm.recipeMethod)" effect="dark" placement="top-start">
                    <div slot="content">
                      <template v-if="editRecipeForm.recipeMethod == '制膏'">预计成品重量{{ Math.trunc((computedWeight(editRecipeForm).count || 0) * 0.4) }}g（制膏量约为药材总重的40%，仅统计单位为g的药材重量）</template>
                      <template v-if="editRecipeForm.recipeMethod == '制丸'">预计成品重量{{ Math.trunc((computedWeight(editRecipeForm).count || 0) * 0.8) }}g（制丸量约为药材总重的80%，仅统计单位为g的药材重量）</template>
                      <template v-if="editRecipeForm.recipeMethod == '打粉'">预计成品重量{{ Math.trunc((computedWeight(editRecipeForm).count || 0) * 0.8) }}g（打粉量约为药材总重的80%，仅统计单位为g的药材重量）</template>
                    </div>
                    <span class="el-icon-info drug_total_icon"></span>
                  </el-tooltip>
                </div>
              </div>
              <div class="del pointer" @click="deleteRecipeItem">
                <span class="iconfont icon-shanch"></span>
              </div>
            </div>
            <div class="drug-list">
              <el-row>
                <vuedraggable :options="dragOptions" forceFallback="true" fallbackClass="fallbackClass"
                  v-model="editRecipeForm.recipeTemplateDrugs">
                  <el-col :span="6"
                    :class="drugIndex == editRecipeForm.recipeTemplateDrugs.length - 1 ? '' : 'drugItem'"
                    v-for="(kid, drugIndex) in editRecipeForm.recipeTemplateDrugs" :key="kid.spuId">
                    <div class="drug-search" @mouseenter="enterKid(kid)" @mouseleave="leaveKid(kid)">
                      <div class="drag-warp">
                        <img class="drag-icon" :src="imgArr.dragIcon" />
                      </div>
                      <div class="search-top">
                        <span class="iconfont icon-tinshou colorF54A mr6" style="size: 12px;" v-if="kid.onSale && kid.onSale == '0'"></span>
                        <el-popover :ref="'popover' + drugIndex" placement="bottom" trigger="click"
                          popper-class="search-popper">
                          <el-input :ref="'search' + drugIndex" slot="reference" class="input-search" type="text"
                            autocomplete="off" spellcheck="false" maxlength="30" v-model="kid.spuCommonName"
                            placeholder="药名" @focus="drugFocus(kid)"
                            @blur="drugSearchBlur(kid.spuCommonName, drugIndex)"
                            @input="getDrugList(kid.spuCommonName, kid.doseType, drugIndex)"
                            @keydown.left.native.prevent="numberInputMove($event, 'left', drugIndex)"
                            @keydown.right.native.prevent="numberInputMove($event, 'right', drugIndex)"
                            @keydown.enter.native="setDrug(kid.spuCommonName, drugIndex)"
                            @keydown.down.native="numberInputMove($event, 'down', drugIndex)"
                            @keydown.up.native="numberInputMove($event, 'up', drugIndex)"></el-input>
                          <div class="customTable">
                            <customTable :highlight-current-row="true" :ref="'customTable' + drugIndex"
                              @row-click="rowClick($event, drugIndex)" :header-cell-style="{ background: '#F5F9FF' }"
                              :column="column" :tableData="drugList" :showPages="false" height="250">
                              <template slot="itemNameHeader">
                                <div class="flex align-i-c"
                                  @click="changeSearchType(kid.spuCommonName, kid.doseType || editRecipeForm.doseType, drugIndex)">
                                  <span class="mr4">{{ searchType == '1' ? '颗粒名称 ' :
                                    '饮片名称'
                                  }}</span>
                                  <img :src="imgArr.changeType" class="change-icon">
                                </div>
                              </template>
                            </customTable>
                          </div>
                        </el-popover>

                        <div style="flex-shrink: 0;flex-grow:0;">
                          <el-input :ref="'dosage' + drugIndex" class="input-dosage" type="text" autocomplete="off"
                            spellcheck="false" maxlength="6" v-model="kid.number" placeholder="用量"
                            @input="formatNum($event, kid)" @focus="dosageFocus(drugIndex)"
                            @keydown.left.native.prevent="numberInputMove($event, 'left', drugIndex)"
                            @keydown.right.native.prevent="numberInputMove($event, 'right', drugIndex)"
                            @keydown.enter.native="searchFocus(drugIndex)"></el-input>
                          <span>{{ kid.unit }}</span>
                        </div>
                      </div>
                      <SelectPanel :ref="'operate' + drugIndex"
                        :class="{ prescription_decoction: true, prescription_decoction_hide: [null, undefined, ''].includes(kid.handling) && kid.isOwned != '1', prescription_decoction_hide_most: [null, undefined, ''].includes(kid.spuId) }"
                        v-model="kid.handling" width="100%" placeholder="煎法" :columnsNum="4" :maxlength="20" :options="handlingOptions"
                        @focus="decoctionFocus(kid)" @input="chooseUsage($event, drugIndex)"
                        @enter="operateEnterFn({ drugIndex })" :disabled="!kid.spuId">
                        <template slot="prefix">
                          <div class="isOwned_warp" v-if="kid.isOwned && kid.isOwned == '1'">【自备】</div>
                        </template>
                        <template slot="footer">
                          <div class="prescription_decoction_footer">
                            <div class="decoction_btn"
                              :class="kid.isOwned && kid.isOwned == '1' ? 'decoction_btn isOwned' : 'decoction_btn'"
                              @click="handleIsOwned(kid)">【自备】</div>
                            <div class="decoction_btn" @click="rememberDecoction(kid)">
                              <span class="decoction_btn_text">记住煎法</span>
                              <img class="decoction_btn_icon"
                                :src="kid.rememberDecoction === true ? starImgMap.starOn : starImgMap.starOff" />
                            </div>
                          </div>
                        </template>
                      </SelectPanel>
                      <i class="el-icon-close" style="font-size: 16px; color:#a7aaae"
                        v-if="kid.deleteShow && editRecipeForm.recipeTemplateDrugs.length != 1 && editRecipeForm.recipeTemplateDrugs.length != drugIndex + 1"
                        @click="removeDrug(drugIndex)"></i>
                    </div>
                  </el-col>
                </vuedraggable>
              </el-row>
            </div>
            <div class="drug-tips">
              <div class="doseNumber">
                <el-input maxlength="3" type="text" v-model="editRecipeForm.doseNum" @input="doseNumChange"
                  style=" width: 40px;"></el-input>
                <span>剂</span>
              </div>
              <div class="dose">
                <SelectPanel v-model="editRecipeForm.recipeMethod" width="60px"
                  :options="drugMethodOptions.map(v => { return { label: v, value: v } })" placeholder="用法" clearable
                  @input="handDrugs">
                </SelectPanel>
              </div>
              <div class="dose" v-for="(val, ind) in computedDrugNoteList(editRecipeForm)" :key="ind">
                <div v-if="val.id == 'mixingBagNum'" class="doseNumber bag" @click="mixingBagNumFocus">
                  每次
                  <el-input ref="mixingBagNum" v-model.trim="editRecipeForm.mixingBagNum" style="width: 20px;"
                    oninput="if(isNaN(value)) { value = null }if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+2) } else if ( value.indexOf('.') === 0 ) { value = null }"
                    :readonly="!val.allowInput" @blur="mixingBagNumBlur">
                  </el-input>
                  袋
                </div>
                <SelectPanel
                  v-else
                  v-model="editRecipeForm[val.id]"
                  :width="val.width || '80px'"
                  :columnsNum="val.id === 'doseFrequency' ? 1 : 3"
                  :placeholder="val.name"
                  :options="val.kid.map(v => { return { label: v, value: v } })"
                  :readonly="!val.allowInput"
                  clearable
                  @input="doseSelectInput(val.id)">
                </SelectPanel>
              </div>
              <div class="dose">
                <el-input placeholder="备注" type="text" style="width: 140px;" v-model="editRecipeForm.remark"></el-input>
              </div>
            </div>
          </div>
          <div v-if="editRecipeForm.type && editRecipeForm.type == '1'">
            <div class="drug-title">
              <div class="drug-index">
                <img :src="imgArr.drugIcon" class="drug-icon">
                <div class="font600 size14 color6671">理疗处方</div>
              </div>
              <div class="del pointer" @click="deleteRecipeItem">
                <span class="iconfont icon-shanch"></span>
              </div>
            </div>
            <div class="physio-content">
              <div v-for="(contentItem, physioIndex) in editRecipeForm.recipeTemplateDrugs" :key="contentItem.spuId">
                <div class="add-warp">
                  <div class="index">
                    <i class="el-icon-plus" v-if="physioIndex == editRecipeForm.recipeTemplateDrugs.length - 1"></i>
                    <span v-else>{{ physioIndex + 1 }}</span>
                  </div>
                  <div class="select-warp">
                    <el-select v-model="contentItem.spuCommonName" :ref="'spuCommonName' + physioIndex"
                      placeholder="选择理疗类型" filterable @change="selectPhysio($event, physioIndex)"
                      :popper-append-to-body="false" popper-class="customSelectStyle">
                      <el-option disabled value="1" style="pointer-events:none;background:#F0F1F3;">
                        <span style="width:300px; display:inline-block">项目名称</span>
                        <span style="width:64px; display:inline-block">单位</span>
                        <span style="width: 104px; display:inline-block">类型</span>
                        <span style="width: 80px; display:inline-block">价格</span>
                        <span style="width: 64px; display:inline-block">医保属性</span>
                      </el-option>
                      <el-option v-for="(obj, index1) in physioOptions" :key="index1" :label="obj.spuCommonName"
                        :value="obj.spuId">
                        <span style="width:300px; display:inline-block">{{ obj.spuCommonName }}</span>
                        <span style="width:64px; display:inline-block">{{ obj.unit || '-' }}</span>
                        <span style="width: 104px; display:inline-block">{{ obj.firstCategoryName || '-'
                        }}</span>
                        <span style="width: 80px; display:inline-block">{{ obj.price }}</span>
                        <span style="width: 60px; display:inline-block">{{
                          computedDictText(obj.medicalInsuranceType, ybPropertyList) || '-'
                        }}</span>
                      </el-option>
                    </el-select>
                  </div>
                  <!-- executionMode 10 按次 20 按组 -->
                  <div class="add-right" v-if="physioIndex != editRecipeForm.recipeTemplateDrugs.length - 1">
                    <div class="edit-warp" style="text-align: center; width: 40px">
                      <div class="w100_" @click="delPhysioProject(physioIndex)"><i
                          class="el-icon-close close-item pointer" style="font-size: 16px;"></i></div>
                    </div>
                  </div>
                </div>
                <div class="acupoint-warp" v-if="physioIndex !== editRecipeForm.recipeTemplateDrugs.length - 1">
                  <div class="acupoint-list">
                    <div class="acupoint-item" v-for="(acupoint, acupointIndex) in contentItem.acupointinfoList"
                      :key="acupoint.acupointId">
                      <div class="acupoint-item-tips" v-if="alreadyAdd == `note${physioIndex}${acupointIndex}`">
                        已添加过该{{ acupoint.speciesType == 10 ? '穴位' : '部位' }}</div>
                      <div class="acupoint-item-tips" v-if="speciesTypeTips == `note${physioIndex}${acupointIndex}`">
                        选择{{ acupoint.speciesType == 10 ? '穴位' : '部位' }}不计入{{ acupoint.speciesType == 10 ? '部位' : '穴位'
                        }}数
                      </div>
                      <el-popover :ref="'popover' + physioIndex + acupointIndex" placement="bottom" trigger="click"
                        popper-class="acupoint-popover" :disabled="acupoint.type == 10">
                        <div class="acupoint-position" v-if="acupoint.type != 50 && acupoint.type != 60">
                          <div class="acupoint-position-item" :class="{
                            'acupoint-position-item-active': acupoint.type == type.value ? true : false,
                            'acupoint-position-item-disabled': acupoint.type != 10 && type.value == 10
                          }" v-for="type in acupointType" :key="type.value"
                            @click="changeAcupointType(type.value, physioIndex, acupointIndex)">{{ type.label }}
                          </div>
                        </div>
                        <div class="acupoint-position" v-if="acupoint.type == 50">
                          <div class="acupoint-position-item" :class="{
                            'acupoint-position-item-active': type == computedAcupointType(acupoint.type, acupoint.typeExtend) ? true : false,
                            'acupoint-position-item-disabled': acupoint.type != 10 && type.value == 10
                          }"
                            v-for="type in AshiPoints" :key="type"
                            @click="changeAcupointType(type, physioIndex, acupointIndex)">
                            {{ type }}</div>
                        </div>
                        <div class="acupoint-SiFen" v-if="acupoint.type == 60">
                          <div>左手：</div>
                          <el-checkbox-group v-model="acupoint.typeExtend" class="mt6" :min="1"
                            @change="$forceUpdate()">
                            <el-checkbox v-for="item in SiFenLeft" :key="item.value" :label="item.value">{{ item.label
                              }}</el-checkbox>
                          </el-checkbox-group>
                          <div class="mt12">右手：</div>
                          <el-checkbox-group v-model="acupoint.typeExtend" class="mt6" :min="1"
                            @change="$forceUpdate()">
                            <el-checkbox v-for="item in SiFenRight" :key="item.value" :label="item.value">{{ item.label
                              }}</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <el-button slot="reference" class="acupoint-item-left">{{
                          computedAcupointType(acupoint.type, acupoint.typeExtend)
                        }}</el-button>
                      </el-popover>
                      <el-select v-model="acupoint.acupointName" :default-first-option="true"
                        :placeholder="contentItem.perUnit | filterPerUnit" filterable popper-class="customSelectStyle"
                        remote reserve-keyword @focus="acupointFocus(acupoint)"
                        :remote-method="query => getAcupointsList(query)"
                        @change="changeAcupoint($event, physioIndex, acupointIndex)">
                        <el-option v-for="item in acupointOptions" :key="item.acupointId" :label="item.acupointName"
                          :value="item.acupointId">
                        </el-option>
                      </el-select>
                      <i class="el-icon-close" @click="deleteAcupoint(physioIndex, acupointIndex)"></i>
                    </div>
                    <div class="acupoint-item">
                      <div class="acupoint-item-tips" v-if="alreadyAdd == `note${physioIndex}`">已添加过该{{
                        contentItem.perUnit |
                        filterPerUnit }}</div>
                      <el-select v-model="acupointName" :default-first-option="true" :ref="'search' + physioIndex"
                        :placeholder="contentItem.perUnit | filterPerUnit" filterable popper-class="customSelectStyle"
                        remote reserve-keyword :remote-method="query => getAcupointsList(query, $event)"
                        @change="selectAcupointName($event, physioIndex)">
                        <el-option v-for="item in acupointOptions" :key="item.acupointId" :label="item.acupointName"
                          :value="item.acupointId">
                        </el-option>
                      </el-select>
                      <div class="acupoint-item-icon" @click="openAcupoint(physioIndex)">
                        <img :src="imgArr.acupointIcon" class="acupoint-icon" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="acupoint-total">
                    {{ contentItem.perUnit | filterPerUnitShow }}：
                    {{ computedPerUnitCount(contentItem) }}
                  </div>
                </div>
                <div class="other-warp" v-if="physioIndex !== editRecipeForm.recipeTemplateDrugs.length - 1">
                  <div class="other-warp-left">
                    <div class="other-num-input">
                      <el-input class="num-input" v-model="contentItem.soldNum"
                        @input="soldNumChange($event, physioIndex)"></el-input>
                      <div>次</div>
                    </div>
                    <div class="other-num-input" @click="clickOnlyNum(physioIndex)"
                      v-if="contentItem.executionMode == 20">
                      <div class="flex-sh">1次</div>
                      <el-input class="onlyNum-input" v-model="contentItem.onlyNum" :ref="'frequencyInput' + physioIndex"
                        @input="onlyNumChange($event, physioIndex)"></el-input>
                      <div>组</div>
                    </div>
                    <div class="frequency-input">
                      <SelectPanel v-model="contentItem.executeDesc" :width="'80px'" :columnsNum="3"
                        :options="physioIntervalEnumOption" :readonly="true" placeholder="频率"
                        @input="physioIntervalEnumChange($event, physioIndex)">
                      </SelectPanel>
                    </div>
                    <div class="other-desc" v-if="contentItem.executionMode == 20 && contentItem.perUnitCount">
                      每组{{ contentItem.perUnitCount }}个{{ contentItem.perUnit == 10 ? '穴位' : '部位' }}，每次至少选择{{
                        $bigNumber(contentItem.perUnitCount, '*',
                          contentItem.onlyNum)
                      }}个{{ contentItem.perUnit == 10 ? '穴位' : '部位' }}</div>
                    <div class="other-desc" v-if="contentItem.executionMode == 10 && contentItem.perUnitCount">
                      每次至少选择{{ contentItem.perUnitCount }}个{{ contentItem.perUnit == 10 ? '穴位' : '部位' }}</div>
                  </div>
                </div>
                <div class="other-warp" v-if="physioIndex !== editRecipeForm.recipeTemplateDrugs.length - 1">
                  <div class="physio_remark_row">
                    <div class="physio_remark_label">理疗备注:</div>
                    <el-input
                      class="physio_product_remark"
                      type="textarea"
                      v-model="contentItem.remark"
                      placeholder="填写相关项目备注信息"
                      :autosize="{ minRows: 1, maxRows: 3 }"
                      resize="none"
                      clearable
                      maxlength="100"
                      show-word-limit
                      @input="physioRemarkInput(contentItem)"
                      @blur="physioRemarkBlur(contentItem)">
                    </el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt20 textRight">
          <el-button class="add-btn" @click="cancel">取消</el-button>
          <el-button class="add-btn" type="primary" @click="recipeSave">确定</el-button>
        </div>
      </div>
      <div slot="footer"></div>
    </CustomDialog>
    <acupoint-dialog v-if="acupointDialogShow" :dialogVisible="acupointDialogShow" @close="acupointDialogClose"
      @accupointConfirm="accupointConfirm" :acupointDialogObj="acupointDialogObj" :tabIndex=acupointDialogObj.tabIndex
      :chooseList="chooseList"></acupoint-dialog>
  </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { DRUG_TYPE, handlingOptions, doseOptions, remarkOptions, drugMethodOptions, frequencyOptions, takingDosageOptions, takeDaysOptions, applicationTimeOptions, soakTimeOptions, takeAmountFOptions, takeAmountGOptions, takeAmountWOptions, doseCanChooseList, doseCanChooseKeys, ybPropertyList } from '@/utils/const'
import {
  typeList, typeEdit, typeAdd, recipeList,
  recipeEdit, recipeAdd, recipeInfo, recipeDelete
} from "@/api/prescription"; // 处方模板请求
import { queryDrugSpu, drugTypeConvert } from "@/api/drug"; // 药品请求
import vuedraggable from 'vuedraggable'; // 拖拽组件
import { deepClone, debounce, isNull, dictText, msgboxWarning } from '@/utils/validateBase';
import customTable from '@/components/customTable/customTable'
import { Utils } from '@/utils/utils';
import { CommonDTO } from '@/DTO/index'
import { imgArr } from '@/assets/images/img'
import { Outpatient } from '../DoctorWorkstation/newDiagnosis/data/index.js'
import SelectPanel from '@/components/SelectPanel.vue'
import { queryPhysio, getPhysioIntervalEnum } from "@/api/physio"; // 理疗请求
import { acupointList } from "@/api/acupoint"; // 穴位请求
import acupointDialog from '@/views/DoctorWorkstation/newDiagnosis/component/acupointDialog.vue'
import { isEmptyArray } from '../../utils/validateBase';

export default {
  // 定义引入的组件
  components: { CustomDialog, vuedraggable, customTable, SelectPanel, acupointDialog },
  props: {
    drugOftenUsageList: {
      type: Array,
      default: function () {
        return []
      }
    },
    title: {
      type: String,
      default: '新增处方'
    },
    dialogShow: {
      type: Boolean,
      default: false
    },
    recipeType: {
      type: String | Number,
      default: ''
    },
    recipeTypeAction: {
      type: String,
      default: ''
    },
    doctorId: {
      type: String | Number,
      default: ''
    },
    form: {
      type: Object,
      default: {}
    }
  },
  filters: {
    filterPerUnit(val) {
      return isNull(val) ? '穴位/部位' : (val == 10 ? '穴位' : '部位')
    },
    filterPerUnitShow(val) {
      return isNull(val) ? '已选' : (val == 10 ? '穴位' : '部位')
    },
  },
  computed: {
    computedDrugNoteList() {
      let that = this
      return function (v) {
        let matchKey = v.recipeMethod
        if (this.doseCanChoose.findIndex(v => v.name === matchKey) === -1) {
          matchKey = '煎服'
        }
        let option = this.doseCanChoose.find(v => v.name === matchKey) || { label: [] }
        return option.label
      }
    },
    computedAcupointType() {
      let that = this;
      return function (type, typeExtend) {
        if (type == 50) {
          return typeExtend[0]
        } else if (type == 60) {
          return isNull(typeExtend) ? 0 : typeExtend.length
        } else {
          return dictText(type, that.acupointType)
        }
      }
    },
    computedPerUnitCount() {
      return function (contentItem) {
        let num = 0
        let { acupointinfoList, perUnit } = contentItem
        if (isNull(perUnit)) {
          acupointinfoList && acupointinfoList.forEach(v => {
            if (v.type == 60) {
              num = num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend.length))
            } else if (v.type == 50) {
              num = num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend[0]))
            } else if (v.type == 20) {
              num = num + 2;
            } else {
              num = num + 1
            }
          })
        } else {
          acupointinfoList && acupointinfoList.forEach(v => {
            if (v.type == 60) {
              num = num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend.length))
            } else if (v.type == 50) {
              num = num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend[0]))
            } else if (v.type == 20) {
              num = num + 2;
            } else {
              num = num + 1
            }
          })
        }
        return num
      }
    },
    //乘法
    computedMultiplication() {
      let that = this
      return function (a, b) {
        return this.$bigNumber(isNull(a) ? 1 : a, '*', isNull(b) ? 1 : b)
      }
    },

    computedDictText() {
      return function (value, list) {
        return dictText(value, list)
      }
    },
    computedWeight () {
      return (editRecipeForm) => {
        let weight = 0
        editRecipeForm.recipeTemplateDrugs.forEach(v => {
          if (v.unit == 'g') {
            weight = this.$bigNumber(weight, '+', v.number)
          }
        })
        return { single: weight, count: this.$bigNumber(weight, '*', (editRecipeForm.doseNum || 1)) }
      }
    }
  },
  data() {
    return {
      starImgMap: {
        starOn: require('@/assets/images/star_on.png'),
        starOff: require('@/assets/images/star_off.png')
      },
      imgArr: imgArr,
      editRecipeForm: {
        recipeTemplateDrugs: []
      },
      typeList: [], // 处方类别列表
      isInputInvalid: false,//必填项校验
      recipeList: DRUG_TYPE,//药品类别列表
      dragOptions: {
        animation: 200,
        draggable: '.drugItem',
        handle: '.drag-warp'
        // filter:'usage- warp'
      },
      handlingOptions: handlingOptions,
      doseOptions: doseOptions,//剂量列表
      remarkOptions: remarkOptions,//备注
      drugMethodOptions: drugMethodOptions,// 使用方式
      frequencyOptions: frequencyOptions,// 服用频次
      takingDosageOptions: takingDosageOptions,// 服用频次
      takeDaysOptions: takeDaysOptions,//服用多少天
      applicationTimeOptions: applicationTimeOptions,//贴敷时间
      soakTimeOptions: soakTimeOptions,//泡浴时间
      takeAmountFOptions: takeAmountFOptions,//打粉每次服用好多g
      takeAmountGOptions: takeAmountGOptions,//制膏每次服用多少
      takeAmountWOptions: takeAmountWOptions,//制丸每次服用多少
      drugList: [],//药品列表
      DrugNote: {//中药处方事项
        recipeMoment: '饭后服用',//服用时机
        frequency: '1日3次',
        takingDosage: '每次200ml',
        takingDays: '服用10天',
        applicationTime: '约敷5分钟',
        wrapTime: '约泡20分钟',
        bakingPowderDosage: '每次10g',
        creamDosage: '每次20g',
        pelletizingDosage: '每次10g',
        mixingBagNum: '1',//冲服
        doseFrequency: '1日1剂'
      },
      doseCanChoose: doseCanChooseList,
      column: [
        { label: "商品名称", prop: 'spuCommonName', align: 'left', slotHeader: "itemNameHeader", width: '200', },
        { label: "类型", prop: "firstCategoryName", align: 'left', width: '90', },
        { label: "单位", prop: "unit", width: '50' },
        { label: "规格", prop: "specifications", width: '120' },
        {
          label: "医保属性", width: '80', prop: "medicalInsuranceType", formatter: (row => {
            return isNull(row.medicalInsuranceType) ? '-' : dictText(row.medicalInsuranceType, ybPropertyList)
          })
        },
      ],//表头
      drugIndex: -1,
      focusIndex: 0,//药品搜索框里输入框聚焦的索引  0药品 1用量
      deptIdList: [],
      curSerVal: '',//当前搜索的值
      searchType: '',//药品搜索值
      isChangeType: false,//是否执行了切换类型：颗粒或者饮片
      physioOptions: [],
      acupointName: '',
      acupointType: [
        { label: '单', value: 10 },
        { label: '双', value: 20 },
        { label: '左', value: 30 },
        { label: '右', value: 40 },
      ],
      physioIntervalEnum: [],
      physioIntervalEnumOption: [],
      acupointDialogShow: false,
      acupointDialogObj: {},
      alreadyAdd: '',//是否添加过
      speciesTypeTips: '',
      focusAcupoint: {},//当前聚焦的穴位信息
      chooseList: [],
      acupointOptions: [],//穴位列表
      loading: false,
      SiFenLeft: [
        { label: '四缝1', value: '1-1' },
        { label: '四缝2', value: '1-2' },
        { label: '四缝3', value: '1-3' },
        { label: '四缝4', value: '1-4' },
      ],
      SiFenRight: [
        { label: '四缝1', value: '2-1' },
        { label: '四缝2', value: '2-2' },
        { label: '四缝3', value: '2-3' },
        { label: '四缝4', value: '2-4' },
      ],
      AshiPoints: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
      ybPropertyList: ybPropertyList
    }
  },
  // 页面初始化
  created() {
    this.editRecipeForm = deepClone(this.form)
    if (this.recipeTypeAction == 'edit') {
      this.editRecipeForm.recipeTemplateDrugs && this.editRecipeForm.recipeTemplateDrugs.forEach(item => {
        item.oldDrugName = item.spuCommonName
      })
      this.editRecipeForm.type == '0' ? this.addSearch(this.editRecipeForm.recipeTemplateDrugs) : this.addSearchPhy(this.editRecipeForm.recipeTemplateDrugs)
    }
    if (this.recipeTypeAction == 'add') {
      this.editRecipeForm.recipeType = this.recipeType
      this.editRecipeForm.type = null
    }
    if (this.recipeTypeAction == 'diagnosisAdd') {
      const typeMap = {
        '1': '0',
        '3': '1'
      }
      this.editRecipeForm.type = typeMap[this.editRecipeForm.recipeType] || '0'
      
      if (this.editRecipeForm.type == '0') {
        this.$set(this.editRecipeForm, 'recipeTemplateDrugs', this.nameChange(this.editRecipeForm.recipeTemplateDrugs, 3))
      }
    }
    this.getPhysioList();
    this.getPhysioIntervalEnum()
    this.getTypeList()
    this.getDeptList()
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    // 服用量失焦数字化处理
    mixingBagNumBlur(e) {
      if (![null, ''].includes(e.target.value)) {
        e.target.value = Number(e.target.value).toString()
      }
    },
    /**
     * 获取全部医馆
     */
    async getDeptList() {
      CommonDTO.getDeptListDTO().then(res => {
        this.deptIdList = res
      })
    },

    addMethod() {
      for (let key in this.editRecipeForm) {
        if (this.editRecipeForm[key] == '' || this.editRecipeForm[key] == null) {
          this.editRecipeForm[key] = this.DrugNote[key]
        }
      }
    },
    /**
     * 取消
     */
    cancel() {
      this.$emit('templateCancel')
    },
    // 获取处方类别
    async getTypeList() {
      let { total, rows, code } = await typeList({ recipeType: this.recipeType });
      if (code == 200) {
        if (total >= 0) {
          this.typeList = rows;
          let typeIndex = this.typeList.findIndex(item => { return item.recipeTemplateTypeId == this.editRecipeForm.recipeTemplateTypeId })
          if (typeIndex > -1) {
            this.editRecipeForm.recipeTemplateTypeName = this.typeList[typeIndex].recipeTemplateTypeName
          }
        }
      }
    },
    /**
 * 药品类型一键转换
 * @param {*} obj 
 */
    typeChange(e) {
      let pre = this.$refs.select.value
      if (Utils.gt(this.editRecipeForm.recipeTemplateDrugs.length, 1)) {
        let typeStr = e == '0' ? '中药饮片' : e == '1' ? '中药颗粒' : ''
        msgboxWarning(this, {
          message: `是否将处方中的所有药品转为${typeStr == '' ? '全部' : typeStr}`,
          confirmFn: async () => {
            this.editRecipeForm.doseType = e
            this.editRecipeForm.recipeTemplateDrugs.pop()
            let { code, data } = await drugTypeConvert({ targetType: e, srcType: pre, drugList: this.editRecipeForm.recipeTemplateDrugs })
            if (code == 200) {
              this.editRecipeForm.recipeTemplateDrugs.forEach(v1 => {
                data.unmatchDrugList && data.unmatchDrugList.forEach((v2,index) => {
                  if (v1.spuId == v2.spuId) {
                    v1.onSale = '0'
                    v1.firstCategory = e
                  }
                })
              })
              this.editRecipeForm.recipeTemplateDrugs.forEach(v1 => {
                data.newDrugList && data.newDrugList.forEach(v2 => {
                  if (v1.spuId == v2.srcSpuId) {
                    v1.firstCategory = v2.firstCategory,
                    v1.spuCommonName = v2.spuCommonName,
                    v1.unit = v2.unit,
                    v1.spuCommonName = v2.spuCommonName,
                    v1.spuId = v2.spuId
                    v1.itemId = v2.spuId
                    v1.onSale = '1'
                  }
                })
              })
              if(!isEmptyArray(data.unmatchDrugList)){
                this.$message.error('未找到对应类型的药品，请更换药品')
              }
              this.addSearch(this.editRecipeForm.recipeTemplateDrugs);
            }
          },
          cancelFn: () => {
            this.editRecipeForm.doseType = pre
          },
        });
      } else {
        this.editRecipeForm.doseType = e
        this.editRecipeForm.recipeTemplateDrugs[0].doseType = e
      }
    },
    enterKid(kid) {
      this.$set(kid, 'deleteShow', true);
      this.$forceUpdate();
    },
    leaveKid(kid) {
      this.$set(kid, 'deleteShow', false);
      this.$forceUpdate();
    },
    /**
     * 药品输入框失去焦点
     */
    drugSearchBlur(val, drugIndex) {
      let recipeTemplateDrugs = deepClone(this.editRecipeForm.recipeTemplateDrugs)
      recipeTemplateDrugs[drugIndex].spuCommonName = recipeTemplateDrugs[drugIndex].oldDrugName
      this.drugIndex = -1
      this.editRecipeForm.recipeTemplateDrugs = recipeTemplateDrugs
    },
    /**
     * 请求药品列表
     * val 药品名字
     * type 药品类型
     */
    getDrugList: debounce(function (val, type, drugIndex) {
      this.curSerVal = val;//当前搜索的值
      queryDrugSpu({ search_value: val, first_category: [type] }).then(res => {
        let { code, data } = res
        if (code == 200) {
          if (_.isEmpty(data)) {
            this.drugList = []
            this.$refs[`popover${drugIndex}`][0].doShow()
          } else {
            this.drugList = data
            this.$refs[`customTable${drugIndex}`][0].$refs.customTable.setCurrentRow(this.drugList[this.drugIndex])
            this.$refs[`popover${drugIndex}`][0].doShow()
          }
        }
      })
    }, 300),
    /**
       * 
       */
    numberInputMove(e, type, drugIndex) {
      let height = 0;
      let dom = this.$refs[`customTable${drugIndex}`][0].$el.querySelector('.el-table__body-wrapper')
      if (this.drugIndex >= 3) {
        height = 40
      }
      switch (type) {
        case 'up':
          if (Utils.gt(this.drugIndex, 0)) {
            this.drugIndex--;
          }
          dom.scrollTop = dom.scrollTop - height
          this.$refs[`customTable${drugIndex}`][0].$refs.customTable.setCurrentRow(this.drugList[this.drugIndex])
          break;
        case 'down':
          if (Utils.gt(this.drugList.length - 1, this.drugIndex)) {
            this.drugIndex++;
          }
          dom.scrollTop = dom.scrollTop + height
          this.$refs[`customTable${drugIndex}`][0].$refs.customTable.setCurrentRow(this.drugList[this.drugIndex])
          break;
        case 'left':
          if (this.focusIndex == 1) {
            this.$refs[`search${drugIndex}`][0].select()
            this.focusIndex = 0
          } else if (this.focusIndex == 0) {
            drugIndex = this.$bigNumber(drugIndex, '-', 1)
            if (Utils.lt(drugIndex, 0)) return
            this.$refs[`dosage${drugIndex}`][0].select()
            this.focusIndex = 1
          }
          break;
        case 'right':
          if (this.focusIndex == 0) {
            this.$refs[`dosage${drugIndex}`][0].select()
            this.focusIndex = 1
          } else if (this.focusIndex = 1) {
            this.searchFocus(drugIndex)
            this.focusIndex = 0
          }
          break;
      }
    },
    setDrug(val, drugIndex) {
      if (isNull(this.drugList[this.drugIndex])) return;
      if (Utils.gt(this.drugIndex, -1)) {
        let row = deepClone(this.drugList[this.drugIndex])
        this.rowClick(row, drugIndex)
      } else {
        this.$refs[`dosage${drugIndex}`][0].focus()
      }
    },
    /**
     * 点击药品表格
     * index 处方索引
     * @param {*} row 
     */
    async rowClick(row, drugIndex) {
      row.itemId = row.spuId
      let obj = deepClone(this.editRecipeForm.recipeTemplateDrugs[drugIndex])
      obj = { ...obj, ...row }
      obj.oldDrugName = row.spuCommonName
      let flag = false
      let recipeTemplateDrugs = this.editRecipeForm.recipeTemplateDrugs
      let length = recipeTemplateDrugs.length
      recipeTemplateDrugs.forEach(item => {
        if (item.spuId == row.spuId) {
          this.$message.error('该处方已添加过该药品！')
          flag = true
        }
      })
      if (flag) return
      recipeTemplateDrugs[drugIndex] = obj
      if (length == 1 || drugIndex == length - 1) {
        this.addSearch(recipeTemplateDrugs)
      }
      this.$set(this.editRecipeForm, 'recipeTemplateDrugs', recipeTemplateDrugs)

      const newDrug = this.editRecipeForm.recipeTemplateDrugs[drugIndex]
      const oftenDecoction = await Outpatient.getOftenDecoction(newDrug.spuId)
      if (oftenDecoction && oftenDecoction.handling) {
        newDrug.handling = oftenDecoction.handling
      } else {
        newDrug.handling = ''
      }

      // this.editRecipeForm.recipeTemplateDrugs = recipeTemplateDrugs
      this.$forceUpdate()
      this.$refs[`popover${drugIndex}`][0].doClose()
      this.drugList = []
      this.$nextTick(() => {
        this.$refs[`dosage${drugIndex}`][0].focus()
      })
      this.drugIndex = -1
      this.curSerVal = ''
    },
    /**
     * 输入药品用量
     */
    formatNum: _.debounce(function (e, kid) {
      if (isNull(e)) return;
      let temp = e.toString();
      temp = temp.replace(/。/g, ".");
      temp = temp.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
      temp = temp.replace(/^\./g, ""); //验证第一个字符是数字
      temp = temp.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
      temp = temp.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      kid.number = temp;
      this.estimateTakingDays()
      this.$forceUpdate()
    }, 50),
    /**
    *  用量输入框聚焦 
    */
    dosageFocus(drugIndex) {
      this.focusIndex = 1;
      this.$refs[`popover${drugIndex}`][0].doClose()
    },
    /**
    * 药品搜索框聚焦
    */
    searchFocus(drugIndex) {
      drugIndex = this.$bigNumber(drugIndex, '+', 1)
      if (Utils.eq(drugIndex, this.editRecipeForm.recipeTemplateDrugs.length)) return;
      let _dosDom = this.$refs[`dosage${drugIndex}`]
      let _searchDom = this.$refs[`search${drugIndex}`]
      let _item = this.editRecipeForm.recipeTemplateDrugs[drugIndex]
      if (!_item.spuCommonName) {
        _searchDom && _searchDom[0].focus()
      } else if (_dosDom && _dosDom[0]) {
        _dosDom[0].focus()
        _dosDom[0].select()
      }
    },
    operateEnterFn(obj) {
      this.searchFocus(obj.drugIndex)
    },
    /**
     * 选择药品煎法
     * index 处方索引
     * drugIndex 药品索引
     */
    chooseUsage(val, drugIndex) {
      let recipeTemplateDrugs = deepClone(this.editRecipeForm.recipeTemplateDrugs)
      recipeTemplateDrugs[drugIndex].handling = val
      if (recipeTemplateDrugs[drugIndex]['rememberDecoction'] === true && ![null, undefined, ''].includes(recipeTemplateDrugs[drugIndex].handling)) {
        Outpatient.saveOftenDecoction(recipeTemplateDrugs[drugIndex].spuId, recipeTemplateDrugs[drugIndex].handling, 1)
      }
      this.editRecipeForm.recipeTemplateDrugs = recipeTemplateDrugs
    },
    /**
    * 删除药品
    * drugIndex 药品索引
    */
    removeDrug(drugIndex) {
      this.editRecipeForm.recipeTemplateDrugs.splice(drugIndex, 1)
      this.estimateTakingDays()
    },
    /**
   * 添加空白搜索框
   * drugList
   */
    addSearch(recipeTemplateDrugs) {
      recipeTemplateDrugs.push({
        doseType: this.editRecipeForm.doseType == '2' ? '0' : this.editRecipeForm.doseType,
        spuCommonName: '',
        number: '',
        unit: 'g',
        deleteShow: false,//是否显示删除icon
        handling: '',
      })
    },
    /**
     * 处理drugItem数据
     * 
     */
    handDrugs() {
      let editRecipeForm = JSON.parse(JSON.stringify(this.editRecipeForm))
      editRecipeForm = this.matchOftenUsageList(editRecipeForm.recipeMethod, this.editRecipeForm)
      this.$set(this, 'editRecipeForm', editRecipeForm)
    },
    doseNumChange: _.debounce(function () {
      if (!this.editRecipeForm.doseNum) {
        this.editRecipeForm.doseNum = '1'
      }
      this.editRecipeForm.doseNum = this.editRecipeForm.doseNum.replace(/^(0+)|[^\d]+/g, '')
      this.estimateTakingDays()
    }, 1000),
    //验证必填项
    validateInput() {
      if (isNull(this.editRecipeForm.recipeTemplateName)) {
        this.isInputInvalid = true
      } else {
        this.isInputInvalid = false
      }
    },
    /**
     * 保存
     */
    recipeSave() {
      let numberFlag = false;
      if (isNull(this.editRecipeForm.type == '0' && this.editRecipeForm.recipeMethod)) return this.$message.error('请选择处方用法')
      if (isNull(this.editRecipeForm.recipeTemplateTypeId)) return this.$message.error('请选择模版类型')
      if (isNull(this.editRecipeForm.type)) return this.$message.error('请选择处方类型')
      this.validateInput()
      if (this.isInputInvalid) { return this.$message.error('请输入名称') }
      this.editRecipeForm.recipeTemplateDrugs && this.editRecipeForm.recipeTemplateDrugs.forEach((item, index) => {
        if (!item.spuId || isNull(item.spuId)) this.editRecipeForm.recipeTemplateDrugs.splice(index, 1)
      })
      if (this.editRecipeForm.type == '0' && this.editRecipeForm.recipeTemplateDrugs.length == 0) {
        this.$message('您未选择药材，请选择后再试！');
        this.addSearch(this.editRecipeForm.recipeTemplateDrugs)
        return;
      }
      let physioDetailFlag = false
      if (this.editRecipeForm.type == '1') {
        this.editRecipeForm.recipeTemplateDrugs && this.editRecipeForm.recipeTemplateDrugs.forEach((v, index) => {
          if (isNull(v.spuId) || isNull(v.spuCommonName)) {
            this.editRecipeForm.recipeTemplateDrugs.splice(index, 1)
            this.$forceUpdate()
          }
        })
        physioDetailFlag = this.editRecipeForm.recipeTemplateDrugs && this.editRecipeForm.recipeTemplateDrugs.some(v => { return isNull(v.executeDesc) })
      }
      if (physioDetailFlag) {
        this.$message.error('请选择理疗执行频率')
        this.addSearchPhy(this.editRecipeForm.recipeTemplateDrugs)
        return;
      }
      if (this.editRecipeForm.type == '1' && this.editRecipeForm.recipeTemplateDrugs.length == 0) {
        this.$message('您未选理疗项目，请选择后再试！');
        this.addSearchPhy(this.editRecipeForm.recipeTemplateDrugs)
        return;
      }
      numberFlag = this.editRecipeForm.recipeTemplateDrugs && this.editRecipeForm.recipeTemplateDrugs.some(item => { return isNull(item.number) || Utils.le(item.number, 0) })
      let onSaleFlag = this.editRecipeForm.recipeTemplateDrugs && this.editRecipeForm.recipeTemplateDrugs.some(item => { return item.onSale == '0' })
      if (this.editRecipeForm.type == '0' && numberFlag) {
        this.$message.error('商品数量不能为空或小于0');
        this.addSearch(this.editRecipeForm.recipeTemplateDrugs)
        return;
      }
      if (this.editRecipeForm.type == '0' && onSaleFlag) {
        this.$message.error('存在不可售药品，请更换');
        this.addSearch(this.editRecipeForm.recipeTemplateDrugs)
        return;
      }
      let typeIndex = this.typeList.findIndex(item => { return item.recipeTemplateTypeId == this.editRecipeForm.recipeTemplateTypeId })
      if (typeIndex == -1) {
        this.editRecipeForm.recipeTemplateTypeName = this.editRecipeForm.recipeTemplateTypeId
        this.editRecipeForm.recipeTemplateTypeId = null
      }
      this.loading = true
      if (this.recipeTypeAction == 'add' || this.recipeTypeAction == 'diagnosisAdd') {
        recipeAdd(this.editRecipeForm).then(res => {
          let { code, data } = res;
          if (code == 200) {
            this.$message.success("新增处方模板成功！");
            this.$emit('saveSuceess', data)
          } else {
            this.errorFun()
          }
        }).catch(() => {
          this.errorFun()
        })
      } else if (this.recipeTypeAction == 'edit') {
        recipeEdit(this.editRecipeForm).then(res => {
          let { code, data } = res;
          if (code == 200) {
            this.$message.success("修改处方模板成功！");
            this.$emit('saveSuceess', data.recipeTemplateId)
          } else {
            this.errorFun()
          }
        }).catch(() => {
          this.errorFun()
        })
      }
    },
    errorFun() {
      this.loading = false
      this.editRecipeForm.type == '0' ? this.addSearch(this.editRecipeForm.recipeTemplateDrugs) : this.addSearchPhy(this.editRecipeForm.recipeTemplateDrugs)
      this.$forceUpdate()
    },
    nameChange(list, type) {
      if (type == 1) {
        return list.map(kid => {
          return {
            spuId: kid.spuId,
            deleteShow: false,
            spuCommonName: kid.spuCommonName,
            number: kid.number,
            handling: kid.handling,
            oldDrugName: kid.drugName,
            unit: kid.unit,
            price: kid.price,
            doseType: kid.doseType,
            isOwned: isNull(kid.isOwned) ? '0' : kid.isOwned,
          }
        })
      }
      if (type == 2) {
        return list.map(kid => {
          return {
            spuCommonName: kid.spuCommonName,
            doseType: kid.doseType,
            number: kid.number,
            unit: kid.unit,
            handling: kid.handling,
            isOwned: isNull(kid.isOwned) ? '0' : kid.isOwned,
          }
        })
      }
      if (type == 3) {
        return list.map(kid => {
          return {
            spuId: kid.spuId,
            deleteShow: false,
            spuCommonName: kid.spuCommonName,
            number: kid.itemNum,
            handling: kid.handling,
            oldDrugName: kid.spuCommonName,
            unit: kid.itemUnit,
            price: kid.price,
            doseType: kid.doseType,
            isOwned: isNull(kid.isOwned) ? '0' : kid.isOwned,
          }
        })
      }
    },
    /**
     * 模版类型改变
     */
    recipeTemplateTypeChange(val) {
      let typeIndex = this.typeList.findIndex(item => { return item.recipeTemplateTypeId == val })
      if (typeIndex > -1) {
        this.editRecipeForm.recipeTemplateTypeName = this.typeList[typeIndex].recipeTemplateTypeName
      }
    },
    /**
     * 搜索药品切换
     */
    changeSearchType(val, type, drugIndex) {

      this.isChangeType = true
      this.$refs[`search${drugIndex}`] && this.$refs[`search${drugIndex}`][0].focus()
      let changeType = this.searchType == '0' ? '1' : '0';
      // this.$set(this.editRecipeForm.recipeTemplateDrugs[drugIndex], 'doseType', changeType)
      // this.$set(this, 'searchType', changeType)
      this.searchType = changeType
      this.$forceUpdate()
      let real = isNull(val) ? this.curSerVal : val;
      this.editRecipeForm.recipeTemplateDrugs[drugIndex].spuCommonName = real;//失焦重新赋值
      this.getDrugList(real, changeType, drugIndex);
      this.isChangeType = false
    },
    /**
     * 药品聚集
     */
    drugFocus(obj) {
      this.drugList = []
      if (this.isChangeType) return
      this.searchType = obj.doseType
      this.focusIndex = 0
    },
    // 服用量获取焦点
    mixingBagNumFocus() {
      this.$refs[`mixingBagNum`][0].focus()
    },
    // 煎法获取焦点
    async decoctionFocus(item) {
      const oftenDecoction = await Outpatient.getOftenDecoction(item.spuId)
      if (oftenDecoction) {
        this.$set(item, 'rememberDecoction', true)
      } else {
        this.$set(item, 'rememberDecoction', false)
      }
    },
    // 记住煎法
    rememberDecoction(item) {
      let rememberDecoction = true
      let enable = 1
      if (item['rememberDecoction'] === true) {
        rememberDecoction = false
        enable = 0
      }
      this.$set(item, 'rememberDecoction', rememberDecoction)
      if (![null, undefined, ''].includes(item.handling)) {
        Outpatient.saveOftenDecoction(item.spuId, item.handling, enable)
      }
    },
    // 匹配常用用法
    matchOftenUsageList(key = '煎服', item) {
      let matchKey = key
      const obj = JSON.parse(JSON.stringify(item))

      doseCanChooseKeys.forEach(key => {
        obj[key] = ''
      })

      if (this.doseCanChoose.findIndex(v => v.name === matchKey) === -1) {
        matchKey = '煎服'
      }
      let defaultOftenUsageOption = this.doseCanChoose.find(v => v.name === matchKey) || { label: [] }
      defaultOftenUsageOption.label.map((v) => {
        obj[v.id] = v.default
      })

      const defaultOftenUsageKeys = defaultOftenUsageOption.label.map(v => v.id)

      const remoteOftenUsageOption = this.drugOftenUsageList.find(v => v.recipeMethod === key)
      if (remoteOftenUsageOption) {
        Object.keys(remoteOftenUsageOption).map(k => {
          if (defaultOftenUsageKeys.includes(k)) {
            obj[k] = remoteOftenUsageOption[k]
          }
        })
      }

      return obj
    },
    //是否自备
    handleIsOwned(kid) {
      if (isNull(kid.isOwned) || kid.isOwned == '0') {
        kid.isOwned = '1'
      } else if (!isNull(kid.isOwned) && kid.isOwned == '1') {
        kid.isOwned = '0'
      }
    },
    addDrug() {
      this.editRecipeForm.type = '0'

      this.editRecipeForm.doseType = ['', null, undefined].includes(this.editRecipeForm.doseType) ? '0' : this.editRecipeForm.doseType

      let recipeTemplateDrugs = []
      recipeTemplateDrugs.push({
        doseType: this.editRecipeForm.doseType == '2' ? '0' : this.editRecipeForm.doseType,
        spuCommonName: '',
        number: '',
        unit: 'g',
        deleteShow: false,//是否显示删除icon
        handling: '',
      })
      this.editRecipeForm.recipeTemplateDrugs = recipeTemplateDrugs
      this.$set(this.editRecipeForm, 'recipeTemplateDrugs', this.nameChange(this.editRecipeForm.recipeTemplateDrugs, 3))
      this.editRecipeForm = this.matchOftenUsageList(this.editRecipeForm.recipeType, this.editRecipeForm)
    },
    addPhysio() {
      this.editRecipeForm.type = '1'
      let recipeTemplateDrugs = []
      recipeTemplateDrugs.push({
        spuId: '',
        itemNum: '',
      })
      this.editRecipeForm.recipeTemplateDrugs = recipeTemplateDrugs
    },
    getPhysioList() {
      queryPhysio().then(res => {
        let { code, data } = res
        if (code == 200) this.physioOptions = [...data];
      })
    },
    //获取理疗执行周期
    async getPhysioIntervalEnum() {
      getPhysioIntervalEnum().then(res => {
        if (res.code == 200) {
          this.physioIntervalEnum = res.data || []
          let list = []
          res.data.forEach(v => {
            list.push({
              label: v.executeDesc,
              value: v.executeDesc
            })
          })
          this.physioIntervalEnumOption = list
        }
      })
    },
    getAcupointsList(acupointName, event) {
      acupointList({ acupointName, speciesType: '' }).then(res => {
        let { code, rows } = res
        if (code == 200) {
          this.acupointOptions = rows;
        }
      })
    },
    addSearchPhy(list) {
      list.push({
        spuCommonName: '',
        spuId: '',
        itemNum: '',
        remark: ''
      })
    },
    selectPhysio(val, physioIndex) {
      let physioItem = deepClone(this.editRecipeForm.recipeTemplateDrugs[physioIndex])
      let findArr = this.editRecipeForm.recipeTemplateDrugs.filter(item => {
        return item.spuId == val
      })
      if (!_.isEmpty(findArr)) {
        this.$message.error('不可以重复添加')
        physioItem.spuCommonName = ''
        physioItem.spuId = ''
        // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = physioItem
        this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, physioItem)
        this.$forceUpdate()
        return;
      }
      // let obj = physioItem[index].items[physioIndex]
      let length = this.editRecipeForm.recipeTemplateDrugs.length
      this.physioOptions.forEach(item => {
        if (item.spuId == val) {
          physioItem = { ...physioItem, ...item }
          physioItem.itemNum = item.executionMode == 20 ? this.$bigNumber(3, '*', 1) : 1
          physioItem.soldNum = 1
          physioItem.onlyNum = item.executionMode == 20 ? 3 : null
          physioItem.acupointinfoList = []
          physioItem.physioIntervalEnum = null
          physioItem['remark'] = ''
        }
      })
      if (length == 1 || physioIndex == length - 1) {
        this.addSearchPhy(this.editRecipeForm.recipeTemplateDrugs)
      }
      this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, physioItem)
      // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = physioItem
      this.$nextTick(() => {
        this.$refs[`search${physioIndex}`][0].focus()
      })
      this.$forceUpdate()
    },
    delPhysioProject(physioIndex) {
      this.editRecipeForm.recipeTemplateDrugs.splice(physioIndex, 1)
      this.$forceUpdate()
    },
    changeAcupointType(val, physioIndex, acupointIndex) {
      let physioItem = deepClone(this.editRecipeForm.recipeTemplateDrugs[physioIndex])
      let acupoint = physioItem.acupointinfoList[acupointIndex]
      if (acupoint.type != 10 && acupoint.type != 60 && acupoint.type != 50 && val == 10) { return }
      if (acupoint.type == 50) {
        acupoint.typeExtend = [`${val}`]
      } else {
        acupoint.type = val
      }
      this.$refs[`popover${physioIndex}${acupointIndex}`][0].doClose()
      // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = physioItem
      this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, physioItem)
      this.$forceUpdate()
    },
    acupointFocus(obj) {
      this.focusAcupoint = deepClone(obj)
    },
    //改变穴位或部位
    changeAcupoint(val, physioIndex, acupointIndex) {
      let physioItem = deepClone(this.editRecipeForm.recipeTemplateDrugs[physioIndex])
      let aIndex = physioItem.acupointinfoList.findIndex(v => {
        return v.acupointId == val
      })
      if (aIndex > -1) {
        this.alreadyAdd = `note${physioIndex}${acupointIndex}`
        physioItem.acupointinfoList[acupointIndex].acupointName = ''
        this.acupointOptions = []
        setTimeout(() => {
          this.alreadyAdd = '';//是否添加过
          physioItem.acupointinfoList[acupointIndex] = this.focusAcupoint
          // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = physioItem
          this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, physioItem)
          this.$forceUpdate()
        }, 2000)
        // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = physioItem
        this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, physioItem)
        this.$forceUpdate()
        return;
      }
      let acupointObj = this.acupointOptions.find(v => { return v.acupointId == val })
      if (acupointObj.type == 50) {
        acupointObj.typeExtend = ['1']
      } else if (acupointObj.type == 60) {
        acupointObj.typeExtend = ['1-1', '1-2', '1-3', '1-4', '2-1', '2-2', '2-3', '2-4']
      }
      physioItem.acupointinfoList[acupointIndex] = acupointObj
      if (physioItem.perUnit && physioItem.perUnit != acupointObj.speciesType) {
        this.speciesTypeTips = `note${physioIndex}${acupointIndex}`
        setTimeout(() => {
          this.speciesTypeTips = '';
        }, 2000)
      }
      // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = physioItem
      this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, physioItem)
      this.$forceUpdate()
      this.acupointName = ''
      this.acupointOptions = []
      this.$nextTick(() => {
        this.$refs[`search${physioIndex}`][0].blur()
        this.$refs[`search${physioIndex}`][0].focus()
      })
    },
    //选择穴位或部位
    selectAcupointName(val, physioIndex) {
      let physioItem = deepClone(this.editRecipeForm.recipeTemplateDrugs[physioIndex])
      let acupointinfoList = physioItem.acupointinfoList || []
      let acupointIndex = acupointinfoList.findIndex(v => {
        return v.acupointId == val
      })
      if (acupointIndex > -1) {
        this.alreadyAdd = `note${physioIndex}`
        this.acupointName = ''
        setTimeout(() => {
          this.alreadyAdd = '';//是否添加过
        }, 2000)
        return;
      }
      let acupoint = this.acupointOptions.find(v => { return v.acupointId == val })
      if (acupoint.type == 50) {
        acupoint.typeExtend = ['1']
      } else if (acupoint.type == 60) {
        acupoint.typeExtend = ['1-1', '1-2', '1-3', '1-4', '2-1', '2-2', '2-3', '2-4']
      }
      physioItem.acupointinfoList.push(acupoint)
      if (physioItem.perUnit && physioItem.perUnit != acupoint.speciesType) {
        this.speciesTypeTips = `note${physioIndex}${physioItem.acupointinfoList.length - 1}`
        setTimeout(() => {
          this.speciesTypeTips = '';
        }, 2000)
      }
      // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = physioItem
      this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, physioItem)
      this.$forceUpdate()
      this.acupointName = ''
      this.acupointOptions = []
      this.$nextTick(() => {
        this.$refs[`search${physioIndex}`][0].blur()
        this.$refs[`search${physioIndex}`][0].focus()
      })
    },
    openAcupoint(physioIndex) {
      let list = this.editRecipeForm.recipeTemplateDrugs[physioIndex].acupointinfoList
      this.chooseList = deepClone(list)
      this.acupointDialogObj.physioIndex = physioIndex
      this.acupointDialogObj.tabIndex = (!isNull(this.editRecipeForm.recipeTemplateDrugs[physioIndex].perUnit) && this.editRecipeForm.recipeTemplateDrugs[physioIndex].perUnit) == 20 ? 2 : 0
      this.acupointDialogShow = true
    },
    acupointDialogClose() {
      this.acupointDialogShow = false
    },
    accupointConfirm(obj) {
      let { physioIndex, chooseList } = obj
      chooseList.forEach(v => {
        if (v.type == 50) {
          v.typeExtend = isNull(v.typeExtend) ? ['1'] : v.typeExtend
        } else if (v.type == 60) {
          v.typeExtend = isNull(v.typeExtend) ? ['1-1', '1-2', '1-3', '1-4', '2-1', '2-2', '2-3', '2-4'] : v.typeExtend
        }
      })
      let item = deepClone(this.editRecipeForm.recipeTemplateDrugs[physioIndex])
      item.acupointinfoList = chooseList
      // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = item
      this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, item)
      this.$forceUpdate()
      this.acupointDialogShow = false
    },
    physioIntervalEnumChange(val, physioIndex) {
      let physioIntervalEnum = this.physioIntervalEnum.find(v => { return v.executeDesc === val })
      let physioItem = deepClone(this.editRecipeForm.recipeTemplateDrugs[physioIndex])
      if (isNull(val)) {
        physioItem.executeDesc = null
        physioItem.physioIntervalEnum = null
      } else {
        physioItem.executeDesc = physioIntervalEnum.executeDesc
        physioItem.physioIntervalEnum = physioIntervalEnum.key
      }
      // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = physioItem
      this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, physioItem)
      this.$forceUpdate()
    },
    deleteRecipeItem() {
      msgboxWarning(this, {
        message: `是否确定删除该处方？`,
        confirmFn: () => {
          this.editRecipeForm.recipeTemplateDrugs = null
          this.editRecipeForm.type = null
        },
        cancelFn: () => {
        },
      });
    },
    soldNumChange(val, physioIndex) {
      let physioItem = deepClone(this.editRecipeForm.recipeTemplateDrugs[physioIndex])
      physioItem.soldNum = physioItem.soldNum.replace(/^(0+)|[^\d]+/g, '')
      physioItem.itemNum = physioItem.executionMode == 20 ? this.$bigNumber(physioItem.onlyNum, '*', val) : physioItem.soldNum
      // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = physioItem
      this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, physioItem)
      this.$forceUpdate()
    },
    onlyNumChange(val, physioIndex) {
      let physioItem = deepClone(this.editRecipeForm.recipeTemplateDrugs[physioIndex])
      physioItem.onlyNum = physioItem.onlyNum.replace(/^(0+)|[^\d]+/g, '')
      physioItem.itemNum = this.$bigNumber(physioItem.soldNum, '*', val)
      // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = physioItem
      this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, physioItem)
      this.$forceUpdate()
    },
    deleteAcupoint(physioIndex, acupointIndex) {
      let physioItem = deepClone(this.editRecipeForm.recipeTemplateDrugs[physioIndex])
      physioItem.acupointinfoList.splice(acupointIndex, 1)
      // this.editRecipeForm.recipeTemplateDrugs[physioIndex] = physioItem
      this.$set(this.editRecipeForm.recipeTemplateDrugs, physioIndex, physioItem)
      this.$forceUpdate()
    },
    clickOnlyNum(physioIndex) {
      this.$nextTick(() => {
        this.$refs[`frequencyInput${physioIndex}`][0].select()
      })
    },
    physioRemarkInput(item) {
      item.remark = item.remark.replace(/[\n]+/g, '')
    },
    physioRemarkBlur(item) {
      if (item.remark && item.remark.trim() == '') {
        item.remark = null
      }
    },
    estimateTakingDays () {
      const form = this.editRecipeForm
      if (['制膏', '制丸', '打粉'].includes(form.recipeMethod)) {
        let weight = 0
        let frequency = form.frequency
        let dosage = ''
        form.recipeTemplateDrugs.forEach(v => {
          if(v.unit == 'g'){
            const tempWeight = this.$bigNumber(v.number, '*', (form.doseNum || 1))
            weight = this.$bigNumber(tempWeight, '+', weight, 2)
          }
        })

        switch (form.recipeMethod) {
          case '制膏':
            weight = Math.trunc((weight || 0) * 0.4)
            dosage = form.creamDosage
            break
          case '制丸':
            weight = Math.trunc((weight || 0) * 0.8)
            dosage = form.pelletizingDosage
            break
          case '打粉':
            weight = Math.trunc((weight || 0) * 0.8)
            dosage = form.bakingPowderDosage
            break
        }
        const takingDays = Utils.estimateTakingDays(weight, frequency, dosage)
        form.takingDays = takingDays
      }
    },
    doseSelectInput (id) {
      if (['frequency', 'creamDosage', 'pelletizingDosage', 'bakingPowderDosage'].includes(id)) {
        this.estimateTakingDays()
      }
    }
  },
}
</script>

<style lang="less" scoped src="./addTemplateDialog.less"></style>
<style lang="less">
.search-popper {
  padding: 0 !important;

  .customTable {
    z-index: 9999;
    top: 25px;
    left: 0;

    .change-icon {
      height: 12px;
      width: 12px;
    }
  }
}

.usage-poppers {
  padding: 0;

  .usage-list {
    background: #FFFFFF;
    box-shadow: 0px 4px 8px 0px rgba(183, 183, 183, 0.25);
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #E1E1E1;

    .usage-item {
      padding: 8px 10px;
      font-size: 15px;
      color: #333;
      cursor: pointer;

      &:hover {
        background: #D4E4FF;
      }
    }
  }

}

.acupoint-popover {
  padding: 0;
  min-width: 120px;
  margin-top: 4px !important;

  .popper__arrow {
    display: none;
  }

  .acupoint-position {
    display: flex;
    border: 1px solid #E0E0E0;
    border-radius: 0px 2px 2px 0px;

    .acupoint-position-item {
      width: 40px;
      height: 38px;
      background: #FFFFFF;
      border-right: 1px solid #E0E0E0;
      text-align: center;
      line-height: 40px;
      cursor: pointer;

      &:last-child {
        border-right: none;
      }
    }

    .acupoint-position-item-active {
      background: #409EFF;
      color: #fff;
    }

    .acupoint-position-item-disabled {
      background: #F7F8F9;
      cursor: not-allowed;
      color: #000 !important;
    }
  }

  .acupoint-SiFen {
    padding: 12px;
    width: 304px;
    box-sizing: border-box;

    .el-checkbox {
      margin-right: 16px;

      .el-checkbox__label {
        padding-left: 3px;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>